import request from "../utils/request";
import {
    RESET_PASSWORD,
    GET_HOME_SECURITIES,
    GET_USER_SECURITIES
} from "@/constants/apis";

export const resetPassword = data => {
    return request({
        method: "put",
        url: RESET_PASSWORD,
        data
    });
};

export const getHomeSecurities = data => {
    return request({
        method: "get",
        url: GET_HOME_SECURITIES,
        data
    });
};

export const getUserSecurities = data => {
    return request({
        method: "get",
        url: GET_USER_SECURITIES,
        data
    });
};
